import React from "react";
import "./Paisa.css";
import paisaLogo from '../Utils/paisa-logo.png';
import PaisaAppInterface from '../Utils/PaisaAppInterface.png'; // Replace with your actual image

const Paisa = () => {
  return (
    <div className="container my-5 paisa-section">
     <div className="mt-5 p-4 bg-white rounded shadow-sm">
  <div className="row align-items-center">
    <div className="col-md-7">
    <h3 className="fw-bold mb-4">Algo Trading</h3>
    <p>
      Algo trading uses advanced algorithms to execute trading strategies
      with unparalleled precision, catering to traders seeking to customise
      their approach for a tailored trading experience. 
      
      </p>
      <p>
      This innovative trading form allows individuals to leverage broker-provided API keys,
      granting access to automated operations that transform complex
      strategies into seamless actions. </p>
      <p>
      Algo trading, gaining momentum for
      its ability to simplify trading through technology, enables even those
      without programming skills to participate effectively.Traders can
      back-test strategies confidently, ensuring their moves are both smart
      and strategic. </p>
      <p>
      As Algo trading becomes increasingly popular, it
      represents the future of trading, offering a platform where strategies
      are not just executed but optimised, marking a significant shift in
      how trading success is achieved and redefining opportunities in the
      financial markets.
    </p>
  </div>

  <div className="col-md-4 text-center">
    <img
      src={paisaLogo}
      alt="Paisa Logo"
      className="img-fluid"
      style={{ maxHeight: '220px' }}
    />
    <h5 className="fw-bold mb-4">Paisa Algo Trading App</h5>
  </div>
  </div>
</div>


      <section className="mt-5 p-4 bg-white rounded shadow-sm">
        <div className="row align-items-center">
          {/* Text Content */}
          <div className="col-md-7">
            <h3 className="fw-bold mb-4">Purpose of Algo Trading</h3>
            <p>
              The purpose of algo trading is to elevate trading efficiency and
              precision by leveraging advanced algorithms to automate and
              optimise trading strategies. This technology enables fast
              execution of orders, surpassing human capabilities and allowing
              for high-frequency trading at an unprecedented scale.
            </p>
            <p>
              Algo Trading significantly reduces the risk of emotional
              decision-making and human errors, integrating sophisticated risk
              management tools for smarter, more strategic trades.
            </p>
            <p>
              Algo trading democratises access to the financial markets by
              simplifying complex strategies, making it accessible even to those
              with minimal programming knowledge. Ultimately, it aims to reduce
              operational costs while providing the flexibility to adapt
              strategies in real-time, ensuring traders can maximise their
              market potential and investment returns efficiently.
            </p>
          </div>

          {/* YouTube Video */}
          <div className="col-md-5 text-center">
            <div className="ratio ratio-16x9">
              <iframe
                width="560"
                height="560"
                src="https://www.youtube.com/embed/ypBk0I5kSSg?si=UTYwyrmaLinGzNbr"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

  

      <section className="container my-5">
  <div className="row align-items-center">
    {/* Image Section */}
    <div className="col-md-4">
      <img
        src={PaisaAppInterface}
        alt="Order Slicer Strategy"
        className="img-fluid rounded shadow-sm"
        style={{ width: "100%", height: "550px", objectFit: "contain" }}
      />
    </div>

    {/* Text Section */}
    <div className="col-md-8">
  <h3 className="fw-bold">Paisa App Interface</h3>
  <p className="text-muted mt-3">
    The <strong>Paisa Algo Trading App</strong> offers a seamless interface for executing option trades based on NIFTY market momentum. Here’s how it works:
  </p>

  <ul className="list-unstyled text-muted">
    <li className="mb-2">
      ✅ <strong>Connect Alice Blue:</strong> Ensure you are logged into your Alice Blue account before starting the app to establish trading connectivity.
    </li>
    <li className="mb-2">
      ✅ <strong>Momentum Detection:</strong> Observe NIFTY trends via TradingView. The app displays a daily <em>Momentum Value (MV)</em> to guide your direction.
    </li>
    <li className="mb-2">
      ✅ <strong>Select Strike Price & Direction:</strong> Choose a suitable strike price (e.g., 24400) and select either <strong>CE</strong> or <strong>PE</strong> based on trend.
    </li>
    <li className="mb-2">
      ✅ <strong>Start Trade:</strong> Tap the <strong>"S"</strong> button to begin trading. The button turns green to indicate an active position.
    </li>
    <li className="mb-2">
      ✅ <strong>Set Target & Stop Loss:</strong> Define your desired profit target and stop loss, which can be modified anytime.
    </li>
    <li className="mb-2">
      ✅ <strong>Manual Exit Option:</strong> If the market moves against you, pressing "S" again sells the position at market price instantly.
    </li>
  </ul>

  <p className="text-muted mt-3">
    This streamlined process helps traders adapt quickly, manage risk effectively, and capture market opportunities with minimal effort.
  </p>
</div>

  </div>
</section>

<section className="mt-4">
        <h4 className="text-center fw-bold mb-4"> Advantages of Algo Trading</h4>
        <div className="row text-center">
          <div className="col-md-3">
            <i className="bi bi-lightning-charge display-4 text-primary"></i>
            <p>Fast Execution</p>
          </div>
          <div className="col-md-3">
            <i className="bi bi-bar-chart-line display-4 text-success"></i>
            <p>Strategy Control</p>
          </div>
          <div className="col-md-3">
            <i className="bi bi-shield-lock display-4 text-warning"></i>
            <p>Risk Management</p>
          </div>
          <div className="col-md-3">
            <i className="bi bi-cpu display-4 text-info"></i>
            <p>Automation</p>
          </div>
        </div>
      </section>



      <section className="bg-light py-5 position-relative">
  <div className="container text-center">
    <div className="row align-items-center justify-content-center">
      <div className="col-md-8">
        <img
          src="https://www.bigul.co/assets-lnp/img/download-app.png" // Replace with the actual path
          alt="Bigul Trading App"
          className="img-fluid"
          style={{ maxWidth: '90%', transform: 'rotate(-10deg)' }}
        />
      </div>
      <div className="col-md-10 mt-4">
        <h2 className="fw-bold">Download Paisa Trading App!</h2>
        <p className="text-muted fs-5">
          Supercharge your trading on the go with the Paisa Trading App! Download now for instant access to cutting-edge features,
          real-time insights, and unparalleled convenience.
        </p>
      </div>
    </div>
  </div>

  {/* Optional background decoration (like floating icons) */}
  <div className="position-absolute top-0 end-0 bottom-0 start-0" style={{ backgroundImage: 'url(/images/background_pattern.png)', opacity: 0.1, backgroundRepeat: 'repeat', pointerEvents: 'none' }} />
</section>


      <section className="mt-5 p-4 rounded shadow-sm bg-white what-we-offer-section">
        <h3 className="fw-bold mb-4">What We Offer</h3>
        <div className="row align-items-center">
          {/* Feature List */}
          <div className="col-md-7">
            <div className="row">
              {[
                "Virtual Trading",
                "Execution Algo",
                "Backtesting",
                "Multiple Segment",
                "Strategy Builder",
                "Prebuild Trading Strategies",
              ].map((item, index) => (
                <div
                  className="col-6 mb-3 d-flex align-items-start"
                  key={index}
                >
                  <i className="bi bi-check2-circle text-success me-2 fs-5"></i>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image Section */}
          <div className="col-md-5 text-center">
            <img
              src="https://www.bigul.co/assets-lnp/img/what-we-offer-image.png"
              alt="What We Offer"
              className="img-fluid"
              style={{ maxHeight: "220px" }}
            />
          </div>
        </div>
      </section>

     
    </div>
  );
};

export default Paisa;
